export class TipoNovedadConstants {
  static ALTA = "Alta"
  static BAJA = "Baja"
  static MODIFICACION = "Modificacion"
}
